import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { map } from 'lodash';
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { Button } from '@wordpress/components';
import { getBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import BlockIcon from '../block-icon';
export default function BlockNavigationList(_ref) {
  var blocks = _ref.blocks,
      selectedBlockClientId = _ref.selectedBlockClientId,
      selectBlock = _ref.selectBlock,
      showNestedBlocks = _ref.showNestedBlocks;
  return (
    /*
     * Disable reason: The `list` ARIA role is redundant but
     * Safari+VoiceOver won't announce the list otherwise.
     */

    /* eslint-disable jsx-a11y/no-redundant-roles */
    createElement("ul", {
      className: "editor-block-navigation__list block-editor-block-navigation__list",
      role: "list"
    }, map(blocks, function (block) {
      var blockType = getBlockType(block.name);
      var isSelected = block.clientId === selectedBlockClientId;
      return createElement("li", {
        key: block.clientId
      }, createElement("div", {
        className: "editor-block-navigation__item block-editor-block-navigation__item"
      }, createElement(Button, {
        className: classnames('editor-block-navigation__item-button block-editor-block-navigation__item-button', {
          'is-selected': isSelected
        }),
        onClick: function onClick() {
          return selectBlock(block.clientId);
        }
      }, createElement(BlockIcon, {
        icon: blockType.icon,
        showColors: true
      }), blockType.title, isSelected && createElement("span", {
        className: "screen-reader-text"
      }, __('(selected block)')))), showNestedBlocks && !!block.innerBlocks && !!block.innerBlocks.length && createElement(BlockNavigationList, {
        blocks: block.innerBlocks,
        selectedBlockClientId: selectedBlockClientId,
        selectBlock: selectBlock,
        showNestedBlocks: true
      }));
    }))
    /* eslint-enable jsx-a11y/no-redundant-roles */

  );
}
//# sourceMappingURL=list.js.map